// !NO MANUAL EDITING ALLOWED. CREATED BY NPM SCRIPT `codegen:localizations`.

export var defaultTranslations = {
  Greetings: 'Hi, welcome to Oriflame!',
  InviteMessageTooltip: 'You were referred by <emphasis>{fullName}</emphasis>. Get in touch to get personalized beauty advice.',
  LiveNow: 'I am live now, join me',
  LiveVideoStartingSoon: 'Live video starting soon',
  ReferralMessageTooltip: 'You were referred by <emphasis>{fullName}</emphasis>. Get in touch to get personalized beauty advice.',
  SeeMyFavoriteProducts: 'See my favorite products',
  SponsorPhoto: "Sponsor's photo",
  WatchLatestVideo: 'Watch my latest live video'
};